(function () {
    realmCommerceApp.controller("ProductDetailController", ProductDetailController);

    /*@ngInject*/
    function ProductDetailController($rootScope, $uibModal, errorsService, product, products, customerService) {
        let vm = this;
        vm.product = {
            id: product.entity_id,
            quantity: 1,
            canAddToCart: true,
            checkAvailability: true,
            showAddToCartButton: false
        };
        vm.constraints = {
            quantity: 1,
            canAddToCart: false,
            availableInCountry: false
        };
        vm.products = products;
        vm.addingToCart = false;
        vm.isProductAlreadyPurchased = isProductAlreadyPurchased;
        vm.searchByModifier = searchByModifier;

        activate();

        function activate() {
            $rootScope.$watchGroup(['vm.addingToCart'], updateCanAddToCart);
        }

        function updateCanAddToCart() {
            vm.product.canAddToCart = !vm.addingToCart;
        }

        function isProductAlreadyPurchased(entityId){
            return customerService.isProductAlreadyPurchased(entityId);
        }

        function searchByModifier(modifier, value){
            const url = '/search?modifiers={"'+ modifier +'": "' + encodeURIComponent(value) + '"}';
            window.location = url;
        }
    }
})();



// WEBPACK FOOTER //
// ./static/js/app/products/product-detail.controller.js